export const htmlEncode = (rawStr) => {
    if (!rawStr) {
        return '';
    }
    return rawStr.replace(
        /[\u00A0-\u9999<>\\&]/gim,
        (char) => ('&#' + char.charCodeAt(0) + ';')
    );
};
